import { jsx as l } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 8c1.815-2.435 4.28-3.94 7-3.94 2.72 0 5.185 1.505 7 3.94-1.815 2.435-4.28 3.94-7 3.94-2.72 0-5.185-1.505-7-3.94Zm1.95-.005c1.47 1.585 3.23 2.44 5.05 2.44 1.815 0 3.58-.86 5.05-2.44C11.58 6.41 9.815 5.555 8 5.555s-3.58.86-5.05 2.44ZM8 10a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 10Zm0-1.5c.275 0 .5-.225.5-.5s-.225-.5-.5-.5-.5.225-.5.5.225.5.5.5Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  n as Show
};
